module.exports = __webpack_public_path__ + "img/pager10img.88ae67f0.jpg";